import React, { useContext } from 'react';

import { Button, EmptyState, Card } from '@ergeon/core-components';
import { UserCircleIcon } from '@ergeon/icons/hero/outline';

import { AuthContext } from '../context-providers/AuthContext';
import useStorageUserID from '../hooks/useStorageUserID';

type RequireAuthUserProps = {
  children: React.ReactNode;
};

const RequireAuthUser: React.FC<RequireAuthUserProps> = ({ children }) => {
  const { user, error, authenticate, isLoading } = useContext(AuthContext);

  // Store user ID in sessionStorage for GA4 tracking
  useStorageUserID();

  if (error) {
    console.error(error);
  }

  if (isLoading) {
    return (
      <Card className="flex flex-col justify-center items-center px-8 pt-8 pb-36 w-full h-screen" flavor="transparent">
        <EmptyState
          actions={<Button
            aria-label="Login In..."
            disabled
            size="medium"
            title="Login with Ergeon Account">
            Login In...
          </Button>}
          description="You need to log in to access application"
          icon={<UserCircleIcon />}
          title="Loading User Data..." />
      </Card>
    );
  }

  if (!user) {
    return (
      <Card className="flex flex-col justify-center items-center px-8 pt-8 pb-36 w-full h-screen" flavor="transparent">
        <EmptyState
          actions={<Button
            aria-label="Login with your Ergeon account"
            onClick={authenticate}
            size="medium"
            title="Login with Ergeon Account">
            Login with Ergeon Account
          </Button>}
          description="You need to log in to access application"
          icon={<UserCircleIcon />}
          title="Not Logged In" />
      </Card>
    );
  }

  return children;
};

export default RequireAuthUser;
